<template>
  <div class="step-two tutorial">
    <h2>Creating a Vue/TypeScript project</h2>
    <h4>Accessing the terminal</h4>
    <h4>Creating and naming your project</h4>
    <h4>Adding libraries (optional)</h4>
  </div>
</template>
